export const billingBillStatus = {
  in_process : 'Em processamento',
  pending_payment: 'Aguardando pagamento',
  paid: 'Pago',
  partially_paid: 'Parcialmente Pago',
  with_integration_failure: 'Falha no SICOF'
};

export const billingBillStatusOptions = Object.entries(billingBillStatus).map(([value, label]) => ({ value, label }));
